export default __webpack_public_path__ + "static/media/formResponse.62c226e2.png";